import React, {Component} from "react"
import { translate } from "react-translate"
import { Segment, Grid } from "semantic-ui-react"
import "./DescriptionDevis.css"
import DevisRow from "./DevisRow";
import {
  defaultColumnWidth,
  nameColumnWidth,
  lastColumnWidth,
  totalSegmentWidth
} from './Constants';
import DevisTotal from "./DevisTotal";
import DevisService from './DevisService';
import _ from 'lodash'
import CommandPanel from "./CommandPanel";

const devisData = [
  {
    number: 1,
    name: "Plomberie",
    quantity: undefined,
    unitPrice : undefined,
    vat: undefined,
    totalPrice : undefined,
    description : "",
    type: "category",
    children : [
      {
        number: 1,
        name: "Piquetage en charge",
        quantity: undefined,
        unitPrice : undefined,
        vat: undefined,
        totalPrice : undefined,
        description : "",
        type: "category",
        children : [
          {
            number: 1,
            name: "Sous taff. (1)",
            description : "Test desc mat",
            type: "category",
            children : [
              {
                number: 1,
                name: "Matériau sous taff 1",
                quantity: 1,
                quantityUnit: "u",
                unitPrice : 15,
                vat: 10,
                totalPrice : 386,
                description : "Test desc mat",
                type: "material"
              }, 
              {
                number: 2,
                name: "Matériau sous taff 2",
                quantity: 1,
                quantityUnit: "u",
                unitPrice : 15,
                vat: 10,
                totalPrice : 386,
                description : "Test desc mat",
                type: "material"
              }, 
            ]
          }, 
          {
            number: 2,
            name: "Matériau à facturer. Ex. : Joint d'étanchéité (2)",
            quantity: 1,
            quantityUnit: "u",
            unitPrice : 15,
            vat: 10,
            totalPrice : 386,
            description : "Test desc mat",
            type: "material"
          }, 
        ]
      }, 
    ]
  }, 
  {
    number: 2,
    name: "Préparation du chantier",
    quantity: undefined,
    unitPrice : undefined,
    vat: undefined,
    totalPrice : undefined,
    description : "Destruction et évacuation des élements à remplacer",
    type: "category",
    children: [
      {
        number: 1,
        name: "Ouvrage expliqué correspondant à une prestation.",
        quantity: 1,
        quantityUnit: "u",
        unitPrice : 139.75,
        vat: 10,
        totalPrice : 135,
        description : "",
        type: "work"
      }, 
      {
        number: 2,
        name: "Ouvrage détaillé correspondant à une prestation.",
        quantity: 1,
        quantityUnit: "u",
        unitPrice : 989.75,
        vat: 10,
        totalPrice : 386,
        description : "",
        type: "work"
      }, 
    ]
  }, 
]


class DescriptionDevis extends Component {

  constructor(props) {
    super(props);
    this.state = {
      devisData
    }

    // Event handlers
    this.onRowClick = this.onRowClick.bind(this);
    this.handleKeyboard = this.handleKeyboard.bind(this);
    this.handleMoveUp = this.handleMoveUp.bind(this);
    this.handleMoveDown = this.handleMoveDown.bind(this);
    this.handleAddMaterial = this.handleAddMaterial.bind(this);
    this.handleAddWorkforce = this.handleAddWorkforce.bind(this);
    this.handleAddWork = this.handleAddWork.bind(this);
    this.handleAddCategory = this.handleAddCategory.bind(this);
    this.handleAddSubcategory = this.handleAddSubcategory.bind(this);
    this.handleAddPageJump = this.handleAddPageJump.bind(this);
    this.handleAddNote = this.handleAddNote.bind(this);
    this.onInsertLineAbove = this.onInsertLineAbove.bind(this);
    this.onInsertPageJumpAbove = this.onInsertPageJumpAbove.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.handleChangeRow = this.handleChangeRow.bind(this);

  }

  onRowClick(rowProps) {
    var cleanAllEdit = DevisService.editAllRow(this.state.devisData, {editing: false})
    var updatedData = DevisService.editTree(cleanAllEdit, rowProps, {editing : true});
    this.setState({
      devisData: updatedData
    });
  }

  handleChangeRow(rowProps, property, value) {
    var editObject = {};
    editObject[property] = value;
    console.log("Should update backend : ", rowProps)
    var updatedData = DevisService.editTree(this.state.devisData, rowProps, editObject);
    this.setState({
      devisData: updatedData
    });
  }

  handleKeyboard(event) {
    var key = event.key;
    if(key === 'Escape') {
      var cleanAllEdit = DevisService.editAllRow(this.state.devisData, {editing: false});
      this.setState({
        devisData : cleanAllEdit
      })
    } else if(key === 'ArrowDown'){
        this.setState({
          devisData : DevisService.selectNext(this.state.devisData)
        })
    } else if (key === 'ArrowUp'){
      this.setState({
        devisData : DevisService.selectPrevious(this.state.devisData)
      })
    }
  }

  handleMoveUp(e, rowProps) {
    e.stopPropagation();
    let modified =  DevisService.moveUp(this.state.devisData, rowProps);
    // TODO : Call backend, modify tree structure, then => setState
    this.setState({
      devisData : modified
    });
  }

  handleMoveDown(e, rowProps){
    e.stopPropagation();
    let modified =  DevisService.moveDown(this.state.devisData, rowProps);
    // TODO : Call backend, modify tree structure, then => setState
    this.setState({
      devisData : modified
    });
  }

  handleAddMaterial() {
    this.setState({
      devisData : DevisService.addMaterial(this.state.devisData)
    });
  }

  handleAddWorkforce() {
    this.setState({
      devisData : DevisService.addWorkforce(this.state.devisData)
    });
  }

  handleAddWork() {
    this.setState({
      devisData : DevisService.addWork(this.state.devisData)
    });
  }

  handleAddCategory() {
    this.setState({
      devisData : DevisService.addCategory(this.state.devisData)
    });
  }

  handleAddSubcategory() {
    this.setState({
      devisData : DevisService.addSubCategory(this.state.devisData)
    });
  }

  handleAddPageJump() {
    console.log("Should add page jump");
  }

  handleAddNote() {
    console.log("Should add note");
  }

  onInsertLineAbove(rowProps) {

  }

  onInsertPageJumpAbove(rowProps) {

  }

  onDelete(rowProps){
    console.log("Should delete row: ", rowProps)
    this.setState({
      devisData : DevisService.removeRow(this.state.devisData, rowProps)
    });
  }

  hasCategory = () => {
    return DevisService.hasCategory(this.state.devisData);
  }

  componentWillMount() {

  }

  render() {
    return (
      <div onKeyDown = {this.handleKeyboard} tabIndex="0">
      <Segment id="devisWrapper">
        <Grid columns="equal">
          <Grid.Row divided>
            <Grid.Column width={defaultColumnWidth}>N °</Grid.Column>
            <Grid.Column width={nameColumnWidth}>Désignation</Grid.Column>
            <Grid.Column width={defaultColumnWidth}>Qté</Grid.Column>
            <Grid.Column width={defaultColumnWidth}>PU HT</Grid.Column>
            <Grid.Column width={defaultColumnWidth}>TVA</Grid.Column>
            <Grid.Column width={lastColumnWidth}>Total HT</Grid.Column>
          </Grid.Row>
          <DevisRow
            id = "rootRow"
            handleClick={(rowProps) => this.onRowClick(rowProps)}
            handleMoveUp ={(e, rowProps) => this.handleMoveUp(e, rowProps)}
            handleMoveDown ={(e, rowProps) => this.handleMoveDown(e, rowProps)}
            onInsertLineAbove={this.onInsertLineAbove}
            onInsertPageJumpAbove={this.onInsertPageJumpAbove}
            onDelete={this.onDelete}
            childrenRows = {this.state.devisData}
            handleChangeRow= {this.handleChangeRow}
            last = {true}
          />
        </Grid>
        <CommandPanel editMode
          handleAddMaterial={() => this.handleAddMaterial()}
          handleAddWorkforce={() => this.handleAddWorkforce()}
          handleAddWork={() => this.handleAddWork()}
          handleAddCategory={() => this.handleAddCategory()}
          handleAddSubcategory = {() => this.handleAddSubcategory()}
          handleAddPageJump={() => this.handleAddPageJump()}
          handleAddNote={() => this.handleAddNote()}
          hasCategory={() => this.hasCategory()}
        />
        <div className="totalWrapper">
          <Segment id="totalGroup" style={{width: totalSegmentWidth + '%'}}>
            <DevisTotal label="Total HT" value="3119,25€"/>
            <DevisTotal label="TVA à 10%" value="15,00€"/>
            <DevisTotal label="TVA à 20%" value="593.85€"/>
            <DevisTotal label="Total TTC" value="3728,10€" dark/>
          </Segment>
        </div>
        
      </Segment>
      </div>
    )
  }

}

export default translate("ProDescriptionDevis")(DescriptionDevis)



// WEBPACK FOOTER //
// ./src/components/Pro/DevisFactures/EditionDevisFactures/DevisComp/DescriptionDevis.jsx